<template>     
    <section class="content">
        <div class="container-fluid p-0 p-md-2">
            <div class="row">
                <div class="col-12">
                    <div class="card">
                        <div class="card-header d-flex flex-column flex-md-row align-items-center justify-content-between">
                            <h3 class="card-title mb-2 mb-md-0 flex-grow-1 text-md-left text-center">Listado de tipos de abonos</h3>
                            <div class="card-tools text-center">
                                <slot name="buttons" ></slot>
                            </div>
                        </div>

                        <div class="card-header">
                            <SearchComponent v-model="filters.search" :disabled="loading" @search="getTipos" />
                        </div>
                        
                        <div class="card-body">
                            <div :class="[esMovil ? 'table-responsive' : '']">
                                <table class="table table-hover">
                                    <thead>
                                        <tr>
                                            <th>Descripción</th>
                                            <th>Stock</th>
                                            <template v-if="!lista.place">
                                                <th class="text-center">Resumen</th>
                                                <th class="text-center">Eventos</th>
                                            </template>
                                            <th class="text-center">Activo</th>
                                            <th class="text-center">Renovación</th>
                                            <th class="text-center">Pago a plazos</th>
                                            <th class="text-center">Opciones</th>
                                        </tr>
                                    </thead>
                                    <tbody v-if="!loading">
                                        <template v-for="(tipo, index) in tipos.data">
                                            <tr :key="index">
                                                <td>{{ tipo.descripcion }}</td>
                                                <td>
                                                    <ul>
                                                        <li>
                                                            <small class="text-nowrap">Stock: {{ tipo.stock }}</small>
                                                        </li>
                                                        <li>
                                                            <small class="text-nowrap">En sesión: {{ tipo.stock_sesion }}</small>
                                                        </li>
                                                        <li>
                                                            <small class="text-nowrap">Total: {{ tipo.stock_calculado }}</small>
                                                        </li>
                                                    </ul>
                                                </td>
                                                <template v-if="!lista.place">
                                                    <td class="text-center">{{ tipo.resumen }}</td>
                                                    <td class="text-center">
                                                        <b-button v-b-popover.hover="'Eventos: ' + tipo.eventos.map(e => e.name).join(', ')" variant="primary" size="sm">
                                                            Ver eventos
                                                        </b-button>
                                                    </td>
                                                </template>
                                                <td class="text-center">
                                                    <CheckOrCross :condition="tipo.activo"/>
                                                </td>
                                                <td class="text-center">
                                                    <CheckOrCross :condition="tipo.renovacion"/>
                                                </td>
                                                <td class="text-center">
                                                    <CheckOrCross :condition="tipo.activar_pago_plazos"/>
                                                </td>
                                                <td class="text-center">
                                                    <OpcionesDropdownTableComponent 
                                                        :lastIndex="tipos.data.length > 3 && index >= tipos.data.length - 3"
                                                        v-bind:options="[
                                                            { to: { name: 'back.abonos.precios.descuentos', params: { precio_id: tipo.id }}, label: 'VER PRECIOS' },
                                                            { type: 'action', action:() => showModal('editarPrecio-' + tipo.id), label: 'EDITAR' },
                                                            { type: 'action', action:() => showModal('borrar-' + tipo.id), label: 'BORRAR' }
                                                        ]" 
                                                        @open="onOpenOptions" 
                                                        @close="onCloseOptions"
                                                    />
                                                </td>
                                            </tr>
                                            <slot name="editarPrecio" :index="index" :tipo="tipo"></slot>
                                            <DeletePrecioModal :key="index + '--'" :precio="tipo" :lista_id="lista.id" @close="closeModal"/>
                                        </template>
                                    </tbody>
                                    <tbody v-else>
                                        <tr>
                                            <td colspan="3">
                                                <LoaderComponent/>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <hr/>
                            <div class="row justify-content-between" v-if="!loading">
                                <div class="col-md-6 col-sm-12">
                                    <ElementosPorPaginaComponent
                                        :value="filters.per_page"
                                        @input="changePerPage"
                                    />
                                </div>
                                <div class="col-md-6 col-sm-12" v-if="tipos">
                                    <PaginateComponent :current_page="tipos.meta.current_page" :last_page="tipos.meta.last_page" @change_page="setPage"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <slot name="configurar-zonas" :tipos="tipos" ></slot>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import DeletePrecioModal from '../../modals/DeletePrecioModal';
    import LoaderComponent from '@/components/preloader/LoaderComponent';
    import CheckOrCross from "@/components/backend/components/CheckOrCross";
    import SearchComponent from "@/components/backend/components/SearchComponent";
    import PaginateComponent from '@/components/table/pagination/BackPaginateComponent';
    import OpcionesDropdownTableComponent from '@/components/backend/components/OpcionesDropdownTableComponent';
    import ElementosPorPaginaComponent from '@/components/backend/components/ElementosPorPaginaComponent.vue';

    export default {
        data() {
            return {
                loading: true,
                filters: {
                    per_page: 10,
                    page: 1,
                    search: '',
                    all: 1
                },
                expand: [],
                tipos: null,
                openOptions: [],
                esMovil: window.innerWidth <= 768
            }
        },
        methods: {
            getTipos() {
                this.loading = true;
                const params = {
                    filters : this.filters,
                    lista_id: this.lista.id
                };

                this.$store.dispatch(this.config.getVuexAlias('back.precios.index'), params).then(res => {
                    this.tipos = res.data;
                    this.loading = false;
                });
            },
            setPage(page) {
                this.filters.page = page;
                this.getTipos();
            },
            showModal(modal) {
                this.$modal.show(modal);
            },
            closeModal(modal, creado) {
                this.expand = [];

                this.openOptions.forEach(opt => opt.close());
                this.openOptions = [];

                if(creado) {
                    this.getTipos();
                }

                this.$modal.hide(modal);
            },
            onOpenOptions(ref) {
                this.openOptions.push(ref);
            },
            onCloseOptions(ref) {
                this.openOptions.split(this.openOptions.indexOf(ref), 1);
            },
            changePerPage(per_page) {
                this.filters.per_page = per_page;
                this.getTipos();
            },
            handleResize() {
                this.esMovil = window.innerWidth <= 768;
            }
        },
        computed: {
            lista() {
                return this.$store.getters.getListaAbonados;
            }
        },
        watch: {
            "filters.search"() {
                this.debouncedGetTipos();
            }
        },
        created() {
            this.getTipos();
            this.debouncedGetTipos = _.debounce(this.getTipos, 500);
            window.addEventListener('resize', this.handleResize);
        },
        destroyed() {
            window.removeEventListener('resize', this.handleResize);
        },
        components: {
            CheckOrCross, LoaderComponent, PaginateComponent, DeletePrecioModal, OpcionesDropdownTableComponent, ElementosPorPaginaComponent, SearchComponent
        }
    }
</script>

<style>
    .multiselect__tag {
        font-size: 9px;
    }
    .multiselect__tag-icon {
        line-height: 17px;
    }
</style>
